import { initialState, intensity } from './state';

export function setPrescriptionRules(state, prescriptionRules) {
  Object.assign(state, { prescriptionRules });
}

export function setPreviousRecommendation(state, previousRecommendation) {
  Object.assign(state, { previousRecommendation });
}

export function reset(state) {
  Object.assign(state, initialState());
}

export function updateSelectedRules(state, selectedRules) {
  Object.assign(state, { selectedRules });
}

export function addToSelectedRules(state, selectedRules) {
  const combined = [...state.selectedRules]
  selectedRules.forEach(rule => {
    if (!combined.includes(rule)) {
      combined.push(rule)
    }
  })
  Object.assign(state, { selectedRules: combined });
}

export function updateHrAtrialFibrilationProvoked(state, hrAtrialFibrilationProvoked) {
  Object.assign(state, { hrAtrialFibrilationProvoked });
}

export function updateHrMyocardialIschemicTreshold(state, hrMyocardialIschemicTreshold) {
  Object.assign(state, { hrMyocardialIschemicTreshold });
}

export function updateHrVentricularTachycardia(state, hrVentricularTachycardia) {
  Object.assign(state, { hrVentricularTachycardia });
}

export function updateHrICDTreshold(state, hrICDTreshold) {
  Object.assign(state, { hrICDTreshold });
}

export function setDefaultRules(state, defaultRules) {
  Object.assign(state, { defaultRules });
}

export function setRecommendation(state, recommendation) {
  Object.assign(state, { recommendation });
  state.vanillaRecommendation = JSON.stringify(recommendation);
}

export function setStartRecommendationNextWeek(state, startRecommendationNextWeek) {
  state.startRecommendationNextWeek = startRecommendationNextWeek
}

export function setRecommendationHeartRate(state, heartRate) {
  Object.assign(state, {
    recommendation: { ...state.recommendation, heartRate },
  });
}

export function setRecommendationHeartRateCooldown(state, heartRateCooldown) {
  Object.assign(state, {
    recommendation: { ...state.recommendation, heartRateCooldown },
  });
}

export function addRecommendationIntensity(state) {
  Object.assign(state, {
    recommendation: {
      ...state.recommendation,
      intensities: [...state.recommendation.intensities, intensity()],
    },
  });
}

export function removeRecommendationIntensity(state, index) {
  Object.assign(state, {
    recommendation: {
      ...state.recommendation,
      intensities: state.recommendation.intensities
        .filter((item, i) => i !== index),
    },
  });
}

export function updateRecommendationIntensity(state, { index, intensity }) {
  Object.assign(state, {
    recommendation: {
      ...state.recommendation,
      intensities: state.recommendation.intensities
        .map((item, i) => {
          if (i === index) {
            return intensity;
          }

          return item;
        }),
    },
  });
}

export function setRecommendationMinFrequency(state, minFrequency) {
  Object.assign(state, {
    recommendation: { ...state.recommendation, minFrequency },
  });
}

export function setRecommendationMaxFrequency(state, maxFrequency) {
  Object.assign(state, {
    recommendation: { ...state.recommendation, maxFrequency },
  });
}

export function setRecommendationFrequencyFlags(state, frequencyFlags) {
  Object.assign(state, {
    recommendation: { ...state.recommendation, frequencyFlags },
  });
}

export function setRecommendationMinSessionDuration(state, minSessionDuration) {
  Object.assign(state, {
    recommendation: { ...state.recommendation, minSessionDuration },
  });
}

export function setRecommendationMaxSessionDuration(state, maxSessionDuration) {
  Object.assign(state, {
    recommendation: { ...state.recommendation, maxSessionDuration },
  });
}

export function setRecommendationSessionDurationFlags(state, sessionDurationFlags) {
  Object.assign(state, {
    recommendation: { ...state.recommendation, sessionDurationFlags },
  });
}

export function setRecommendationMinProgramDuration(state, minProgramDuration) {
  Object.assign(state, {
    recommendation: { ...state.recommendation, minProgramDuration },
  });
}

export function setRecommendationMaxProgramDuration(state, maxProgramDuration) {
  Object.assign(state, {
    recommendation: { ...state.recommendation, maxProgramDuration },
  });
}

export function setRecommendationProgramDurationFlags(state, programDurationFlags) {
  Object.assign(state, {
    recommendation: { ...state.recommendation, programDurationFlags },
  });
}

export function setRecommendationAdditionalTrainingStrategies(state, additionalTrainingStrategies) {
  Object.assign(state, {
    recommendation: { ...state.recommendation, additionalTrainingStrategies },
  });
}

export function setRecommendationChangeReason(state, changeReason) {
  Object.assign(state, {
    recommendation: { ...state.recommendation, changeReason },
  });
}

export function setRecommendationStrengthTrainingFlags(state, strengthTrainingFlags) {
  Object.assign(state, {
    recommendation: { ...state.recommendation, strengthTrainingFlags },
  });
}

export function setAdditionalTrainingStrategies(state, additionalTrainingStrategies) {
  Object.assign(state, {
    recommendation: { ...state.recommendation, additionalTrainingStrategies },
  });
}

export function toggleRecommendationHITIntensity(state, hasHIT) {
  Object.assign(state, {
    recommendation: { ...state.recommendation, hasHIT },
  });
}

export function toggleRecommendationSaved(state, isRecommendationSaved) {
  Object.assign(state, { isRecommendationSaved });
}

export function setHistoryPrescriptions(state, prescriptions) {
  Object.assign(state.history, { prescriptions });
}

export function setHistorySelectedPrescriptionId(state, selectedPrescriptionId) {
  Object.assign(state.history, { selectedPrescriptionId });
}

export function setSelectedPrescriptionPatientSummary(state, selectedPrescriptionPatientSummary) {
  Object.assign(state.history, { selectedPrescriptionPatientSummary });
}

export function setRecommendationUpdatedByAlgorithm(state, recommendationUpdatedByAlgorithm) {
  Object.assign(state, {
    recommendationUpdatedByAlgorithm,
    recommendationReverted: false
  });
}

export function setRecommendationReverted(state, recommendationReverted) {
  Object.assign(state, { recommendationReverted });
}
